<template>
  <div @click.stop="checkIfAutobidEnabled() && showAutoBidDialog(true)">
    <v-icon :color="active ? 'brand' : ''">gavel</v-icon> Autobid

    <v-dialog v-model="autoBidDialog" :persistent="true" max-width="500px">
      <div style="position: relative; background-color: #fff; text-align: center; padding: 2rem 1rem;">
        <v-icon style="cursor: pointer; position: absolute; right: 0; top: 0; padding: 0.5rem;" @click.stop="showAutoBidDialog(false)">close</v-icon>
        <div style="font-size: 1.4rem; font-weight: 400;">Set up Autobid</div>
        <div style="padding: 1rem 3rem 0;">
          <form id="autoBidForm" ref="autoBidForm" @submit.prevent style="padding: 0 3rem 0;">
            <div class="clearfix" style="margin-bottom: 1rem;">
              <div class="col12" style="margin-top: 0.6em; text-align: left;"><label for="increment">Increments</label></div>
              <div class="col12">
                <currency-input id="increment" v-model="autobid.increment" />
              </div>
            </div>
            <div class="clearfix">
              <div class="col12" style="margin-top: 0.6em; text-align: left;"><label for="threshold">Until it reaches</label></div>
              <div class="col12">
                <currency-input id="threshold" v-model="autobid.threshold" />
              </div>
            </div>
            <div style="margin: 2em 0 0; font-size: 1rem;">
              <button @click.stop="deleteAutoBid()" :disabled="!active" class="mr-1">Remove autobid</button>
              <button @click.stop="setAutoBid()">Set autobid</button>
            </div>
          </form>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
  import CurrencyInput from './CurrencyInput.vue'
  import { mapGetters, mapMutations } from 'vuex'
  import { auctionRoles } from '../../utils/PfxUtils.js'

  export default {
    name: 'AutoBidWidget',
    components: {
      CurrencyInput
    },
    props: {
      initialAuction: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        autobid: {
          increment: 0,
          threshold: 0,
          status: 'INACTIVE'
        }
      }
    },
    computed: {
      ...mapGetters([
        'autoBidAllowed',
        'autoBidDialog'
      ]),
      active() {
        return this.autobid.status !== 'INACTIVE'
      },
      minimumThreshold() {
        return (
          Math.max(
            this.initialAuction.startingPrice,
            this.initialAuction.currentPrice
          ) + this.initialAuction.minimumIncrement
        )
      },
      myRole() {
        return this.initialAuction.role.role || auctionRoles.ANONYMOUS.value
      }
    },
    created() {
      this.resetAutoBid()
      this.readAutoBid()
    },
    methods: {
      ...mapMutations(['showAutoBidDialog']),
      checkIfAutobidEnabled() {
        if (!this.autoBidAllowed) {
          this.$store.commit('openDialog', 'Autobid is not available in this auction.')
          return false
        }
        console.log(this.initialAuction.role)
        if (this.initialAuction.role.role !== auctionRoles.BUYER.value) {
          this.$store.commit('openDialog', 'You must a registered buyer for this auction to set an autobid.')
          return false
        }
        return true
      },
      setAutoBid() {
        document.getElementById('increment').setCustomValidity('')
        document.getElementById('threshold').setCustomValidity('')
        if (this.autobid.increment < this.initialAuction.minimumIncrement) {
          document.getElementById('increment').setCustomValidity('Minimum increment is ' + this.initialAuction.minimumIncrement)
          return
        }
        if (this.autobid.threshold < this.minimumThreshold) {
          document.getElementById('threshold').setCustomValidity('Value is too low')
          return
        }
        this.updateAutoBid()
      },
      updateAutoBid() {
        this.$PfxBackendApi
          .updateAutoBid(
            this.initialAuction.tenant.subdomain,
            this.initialAuction.id,
            this.initialAuction.role.id,
            {
              increment: this.autobid.increment,
              threshold: this.autobid.threshold
            }
          )
          .then(res => {
            Object.assign(this.autobid, res.data)
            this.$notify({ type: 'success', message: 'Autobid settings updated' })
          })
          .catch(err => {
            console.error('updateAutoBid err', err)
            this.$notify({ type: 'danger', message: 'Autobid update failed' })
          })
          .then(this.showAutoBidDialog(false))
      },
      readAutoBid() {
        if (this.autoBidAllowed && this.myRole === auctionRoles.BUYER.value && this.initialAuction.role.id) {
          this.$PfxBackendApi
            .readAutoBid(
              this.initialAuction.tenant.subdomain,
              this.initialAuction.id,
              this.initialAuction.role.id
            )
            .then(res => {
              console.log('readAutoBid res', res)
              Object.assign(this.autobid, res.data)
            })
            .catch(err => {
              // 404 means that there is no autobid set -> defaults are fine.
              if (err.status !== 404) {
                console.error('readAutoBid err', err)
                this.$notify({type: 'danger', message: 'Error reading Autobid settings'})
              }
            })
        }
      },
      deleteAutoBid() {
        this.$PfxBackendApi
          .deleteAutoBid(
            this.initialAuction.tenant.subdomain,
            this.initialAuction.id,
            this.initialAuction.role.id
          )
          .then(() => {
            this.resetAutoBid()
            this.$notify({ type: 'success', message: 'Autobid removed' })
          })
          .catch(err => {
            console.error('deleteAutoBid err', err)
            this.$notify({ type: 'danger', message: 'Error while removing autobid' })
          })
          .then(this.showAutoBidDialog(false))
      },
      resetAutoBid() {
        this.autobid = {
          increment: this.initialAuction.minimumIncrement,
          threshold: this.minimumThreshold,
          status: 'INACTIVE'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import 'node_modules/jeet/scss/index';

  .col12 { @include column(1/2, $gutter: 0); }

  #autoBidForm {
    label {
      font-size: 1rem;
      font-weight: 400;
    }
    input {
      height: 2em;
      font-size: 1em;
      width: 180px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/elements/AutoBidWidget.vue